import { MemberadminTFunction } from '@dap/memberadmin/i18n';
import { MgParticipantType } from '@dap/memberadmin/types';

export function getMgParticipantIdLabel(
  mgParticipantType: MgParticipantType | undefined,
  t: MemberadminTFunction
): string {
  return mgParticipantType === MgParticipantType.SUPPLIER
    ? t('location.supplierNumber')
    : t('location.membershipNumber');
}
